module.exports = __webpack_public_path__ + "static/img/xxjl.96fc54d5.png";